import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Lottie from 'lottie-react';
import celebration from '../../../../../assets/lottie/celebration.json';

const FinalReviewForm = () => {
  return (
    <>
      <Row>
        <Col className="text-center">
          <div className="wizard-lottie-wrapper">
            <div className="wizard-lottie mx-auto">
              <Lottie animationData={celebration} loop={true} />
            </div>
          </div>
          <h4 className="mb-1">
            You have filled in all the required information.
          </h4>
          <p className="fs-8">You can now publish your listing.</p>
        </Col>
      </Row>
    </>
  );
};

export default FinalReviewForm;
